import AddressForm from './address';
import ContactForm from './contact';
import InviteForm from './invite';
import ExtendForm from './extend';
import TerminateForm from './terminate';
import RejectICW2Form from './rejectICW2';
import DeleteAssignmentForm from './deleteAssignment';

export { AddressForm, ContactForm, InviteForm, ExtendForm, TerminateForm, DeleteAssignmentForm, RejectICW2Form };



// WEBPACK FOOTER //
// ./src/components/forms/index.js